__turbopack_context__.v({
  "className": "corp_c35d7922-module__jrLEtG__className",
  "variable": "corp_c35d7922-module__jrLEtG__variable",
});
